import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import noimage from "../../assets/img/noimage.png";
import { useNavigate } from 'react-router-dom';

const UserAdd = () => {

    const [uploadimg, setUploadimg] = useState(null);
    const navigate = useNavigate();
    const handleChangeimg = (e) => {
        setUploadimg(URL.createObjectURL(e.target.files[0]));
    }

    return (
        <div className="cmsadd">
            <button className="btn sitebtn mb-4" onClick={()=>navigate(-1)}>Back</button>
            <h1 className="pagehead">User Add</h1>
            <div className="cardbox">
                <Form>
                    <Row>
                        <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                            <Form.Group>
                                <Form.Label>Title</Form.Label>
                                <Form.Control type="text" />
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                            <Form.Group>
                                <Form.Label>Subtitle</Form.Label>
                                <Form.Control type="text" />
                            </Form.Group>
                        </Col>
                        <Col xs={12}>
                            <Form.Group className="mb-4">
                                <Form.Label>Description</Form.Label>
                                <SunEditor height={300} />
                            </Form.Group>
                        </Col>
                        <Col xs={12} className="mb-4">
                            <Form.Group>
                                <Form.Label>Image</Form.Label>
                                <div className="uploadimgbox">
                                    <img src={uploadimg ? uploadimg : noimage} alt="user" className="img-fluid" />
                                    <Form.Control type="file" onChange={handleChangeimg} />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
                <button type="button" className="btn sitebtn py-2 px-3">Add</button>
            </div>
        </div>
    )
}

export default UserAdd;